import Vue from "vue";
//element-ui 懒加载自指令
Vue.directive("el-select-lazyloading", {
    // 当被绑定的元素插入到 DOM 中时……
    bind(el, binding) {
            console.log(el,binding,'el-select-lazyloading')
            let SELECT_DOM = el.querySelector(
                ".el-select-dropdown .el-select-dropdown__wrap"
            );
            SELECT_DOM.addEventListener("scroll", function () {
                let condition = Math.floor(this.scrollHeight - this.scrollTop) <= this.clientHeight//距离视窗底部5像素开始加载数据
                //scrollHeight 整个可以滚动区域的高度
                //scrollTop 滚动条距离滚动区域顶部的高度，可以视为已经滚动的高度
                //clientHeight 视口高度
                console.log(this.scrollHeight - this.scrollTop,this.clientHeight,condition)
                if (condition) {
                    binding.value();
                }
            })
    }
});
